import { getMostRecentTerminalInAircraft } from './ConnectionStatusUtils';
import { isNotNullOrUndefined } from './NullUtils';
import Terminal from '../shared/entities/terminal';

/**
 * Pans to the most recently online terminal on the platform as long as it is not hidden.
 * @param datapathUuid the terminal id to pan to on the map
 * @param terminals all the terminals that are present on the map
 * @param panTo callback function to pan to the most recent terminals lat long coords
 * @param hiddenDatapathUuids the hidden terminals on the map
 */
export const panToTerminalOnMap = (
  datapathUuid: string,
  terminals: { [datapathUuid: string]: Terminal },
  panTo: (obj: google.maps.LatLngLiteral) => void,
  hiddenDatapathUuids?: string[],
) => {
    let onlineTerminal = getMostRecentTerminalInAircraft(terminals[datapathUuid], terminals);
    if (
      onlineTerminal &&
      isNotNullOrUndefined(onlineTerminal.latitudeDeg) &&
      isNotNullOrUndefined(onlineTerminal.longitudeDeg) &&
      (!hiddenDatapathUuids || !hiddenDatapathUuids.includes(datapathUuid))
    ) {
      panTo({ lat: onlineTerminal.latitudeDeg, lng: onlineTerminal.longitudeDeg });
    }
};
